import React from 'react';
import PropTypes from 'prop-types';
import styles from './AttachmentView.module.css';
import { useDownloadButtonClicked } from '../../HelperMethods/CommonHooks';

export default function AttachmentView({ name, isDownloadable, onRemoveButtonClick, attachment }) {
  const onDownloadButtonClicked = useDownloadButtonClicked(attachment);
  return (
    <div className={styles.attachmentBox}>
      <i className="fa fa-paperclip" />
      <span
        onClick={isDownloadable ? onDownloadButtonClicked : null}
        style={{ cursor: isDownloadable ? 'pointer' : 'auto' }}
        title={isDownloadable ? 'Click to Download' : undefined}
      >
        {name}
      </span>
      {onRemoveButtonClick && (
        <button className={styles.buttons} onClick={onRemoveButtonClick} type="button">
          <i className="fa fa-times" />
        </button>
      )}
    </div>
  );
}

AttachmentView.propTypes = {
  name: PropTypes.string.isRequired,
  isDownloadable: PropTypes.bool,
  onRemoveButtonClick: PropTypes.func,
  attachment: PropTypes.shape({
    key: PropTypes.string.isRequired,
    bucket: PropTypes.string.isRequired,
    region: PropTypes.string.isRequired,
  }).isRequired,
};
